exports.init = function($) {
  resizeSwapImages($);

  $(window).on('resize', function() {
    resizeSwapImages($);  
  });
}

function resizeSwapImages($) {
  $(".js-resize-swap").each(function() {
    const breakpoint = parseInt($(this).data('breakpoint')) || 768
    $(this).css({backgroundImage: `url(${$(this).data(window.innerWidth > breakpoint ? 'background-image' : 'mobile-background-image')})` })
  });
}